export default "__VITE_ASSET__CmUUCRYm__"